import React from "react";
import { Box, Container, Typography, Stack } from "@mui/material";
import MobilesImg from "../assets/Mobiles.png";
import AppleStoreImg from "../assets/appleStore.png";
import PlayStoreImg from "../assets/playStore.png";
import WellnessLogo from "../assets/wellness-logo.png";
import useResponsive from "../hooks/useResponsive";
import { useLandingPage } from "../context/LandingPageContext";

export default function WellnessJourneySection() {
  const { isMobile, isTablet, isSmallScreen } = useResponsive();
  const { landingData, loading } = useLandingPage();

  const storeLinks = {
    appStoreUrl: landingData?.appStoreUrl || "",
    playStoreUrl: landingData?.playStoreUrl || "",
  };

  return (
    <Box
      id="download"
      sx={{
        width: "100%",
        py: { xs: 4, md: 6, lg: 8 },
        px: { xs: 2, sm: 3, md: "60px" },
        backgroundColor: "#FCFBF9",
      }}
    >
      <Container maxWidth="xl" disableGutters>
        <Box
          sx={{
            width: "100%",
            minHeight: "500px",
            borderRadius: "24px",
            display: "flex",
            flexDirection: { xs: "column", lg: "row" },
            alignItems: "stretch",
            justifyContent: "space-between",
            overflow: "hidden",
          }}
        >
          {/* Left Content - Green Background */}
          <Box
            sx={{
              flex: { xs: "1 1 auto", lg: "0 0 56%" },
              minHeight: { xs: "400px", sm: "450px", md: "500px" },
              backgroundColor: "#5B8C6F",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              px: { xs: 4, sm: 5, md: 6, lg: 8 },
              py: { xs: 5, sm: 6, md: 8 },
              gap: { xs: 2, md: 2.5 },
            }}
          >
            {/* Logo Icon */}
            <Box
              component="img"
              src={WellnessLogo}
              alt="Wellness Logo"
              sx={{
                width: { xs: 44, sm: 50, md: 56 },
                height: "auto",
                filter: "brightness(0) invert(1)",
                opacity: 0.95,
              }}
            />

            <Typography
              variant="h3"
              sx={{
                fontFamily: "'Poppins', sans-serif",
                fontWeight: 700,
                fontSize: { xs: "22px", sm: "26px", md: "30px", lg: "34px" },
                lineHeight: 1.25,
                color: "#FFFFFF",
                maxWidth: { xs: "280px", sm: "340px", md: "100%" },
              }}
            >
              Start Your Wellness Journey Today
            </Typography>

            <Typography
              sx={{
                fontFamily: "'Poppins', sans-serif",
                fontWeight: 400,
                fontSize: { xs: "13px", sm: "14px", md: "15px", lg: "16px" },
                lineHeight: 1.6,
                color: "rgba(255, 255, 255, 0.85)",
                maxWidth: { xs: "320px", sm: "380px", md: "380px" },
              }}
            >
              Take a moment for yourself. Your calmer, clearer self is one
              breath away.
            </Typography>

            {/* App Store Badges */}
            <Stack
              direction="row"
              spacing={{ xs: 1.5, md: 2 }}
              sx={{
                justifyContent: "center",
                alignItems: "center",
                flexWrap: "wrap",
                mt: { xs: 1, md: 1.5 },
              }}
            >
              <Box
                component="img"
                src={AppleStoreImg}
                alt="Download on the App Store"
                onClick={() => {
                  if (storeLinks.appStoreUrl) {
                    window.open(
                      storeLinks.appStoreUrl,
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }
                }}
                sx={{
                  height: { xs: 38, sm: 40, md: 44 },
                  width: "auto",
                  cursor: "pointer",
                  transition: "transform 0.25s ease",
                  "&:hover": {
                    transform: "scale(1.06)",
                  },
                }}
              />

              <Box
                component="img"
                src={PlayStoreImg}
                alt="Get it on Google Play"
                onClick={() => {
                  if (storeLinks.playStoreUrl) {
                    window.open(
                      storeLinks.playStoreUrl,
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }
                }}
                sx={{
                  height: { xs: 38, sm: 40, md: 44 },
                  width: "auto",
                  cursor: "pointer",
                  transition: "transform 0.25s ease",
                  "&:hover": {
                    transform: "scale(1.06)",
                  },
                }}
              />
            </Stack>
          </Box>

          {/* Right Content - Beige with Mobiles */}
          <Box
            sx={{
              flex: { xs: "1 1 auto", lg: "0 0 44%" },
              backgroundColor: "#F0EBE3",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              overflow: "hidden",
              minHeight: { xs: "260px", sm: "300px", md: "340px", lg: "auto" },
              py: { xs: 3, sm: 4, md: 5, lg: 0 },
            }}
          >
            <Box
              component="img"
              src={MobilesImg}
              alt="Wellness App Mobile Screens"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: { xs: "contain", lg: "cover" },
                display: "block",
              }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}